import { environment } from '../../environments/environment';

export const version = environment.VERSION || '0.0.0';

export * from './backend';
export * from './s3-files';
export * from './security';
export * from './segment';
export * as flagsmith from './flagsmith';
export { backendServiceUrl, crmServiceUrl, locationServiceUrl, dimAdminApiUrl, pdObserverUrl } from './services';
